import map from "lodash/map";
import { DOCUMENT_OBJECT_ATTRIBUTE_ID_PREFIX_CORE } from "../constants";
const regex = /^[A-Za-z_]+(?<index>\d+)$/;
export default (graphComponentRef) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph))
        return `${DOCUMENT_OBJECT_ATTRIBUTE_ID_PREFIX_CORE}1`;
    const matches = graphComponentRef.current.graph.nodes.toArray().map(n => {
        var _a;
        const attributes = (_a = n.tag) === null || _a === void 0 ? void 0 : _a.Attributes;
        if (!attributes)
            return 0;
        return Math.max(...map(attributes, attr => {
            var _a;
            const groups = (_a = attr.Id.match(regex)) === null || _a === void 0 ? void 0 : _a.groups;
            return (groups === null || groups === void 0 ? void 0 : groups.index) ? parseInt(groups === null || groups === void 0 ? void 0 : groups.index) : 0;
        }));
    });
    return `${DOCUMENT_OBJECT_ATTRIBUTE_ID_PREFIX_CORE}${Math.max(...matches) + 1}`;
};
